import React from "react";
import { makeStyles, withStyles } from "@material-ui/core";
import type { ToggleButtonGroupProps, ToggleButtonProps } from "@material-ui/lab";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import clsx from "clsx";

import type { CoretexTheme } from "../theme";
import Tooltip from "./Tooltip";

const useStyles = makeStyles((theme: CoretexTheme) => ({
  selected: {
    "&$selected": {
      backgroundColor: theme.palette.colour.primaryBlue,
      "&:hover": {
        backgroundColor: theme.palette.colour.primaryBlue,
      },
    },
  },
  root: {
    backgroundColor: theme.palette.mono.lightGray,
    "&:hover": {
      backgroundColor: theme.palette.mono.lightGray,
    },
    border: "none",
    cursor: "pointer",
    width: 32,
    height: 32,
    borderRadius: "5px",
    marginRight: theme.spacing(2),
    padding: 0,
  },
  labelWrapper: {
    height: "100%",
  },
  label: {
    width: "100%",
    height: "100%",
    display: "inherit",
    alignItems: "inherit",
    justifyContent: "inherit",
    padding: "8px",
  },
  labelDeselected: {
    "& > *": {
      "& > *": {
        fill: theme.palette.mono.secondaryDark,
      },
    },
    "&:hover": {
      "& > *": {
        "& > *": {
          fill: theme.palette.colour.primaryBlue,
        },
      },
    },
  },
  labelSelected: {
    "& > *": {
      "& > *": {
        fill: theme.palette.mono.white,
      },
    },
  },
}));

interface IconToggleButtonProps extends ToggleButtonProps {
  tooltip?: string;
}

export const IconToggleButton = ({ children, tooltip, ...props }: IconToggleButtonProps): JSX.Element => {
  const classes = useStyles();

  return (
    <ToggleButton
      {...props}
      classes={{ selected: classes.selected, root: classes.root, label: classes.labelWrapper }}
      disableRipple
    >
      <Tooltip arrow placement="top" title={tooltip ?? ""}>
        <span
          className={clsx(
            classes.label,
            !props.selected && classes.labelDeselected,
            props.selected && classes.labelSelected,
          )}
        >
          {children}
        </span>
      </Tooltip>
    </ToggleButton>
  );
};

const IconToggleGroup: React.ComponentType<ToggleButtonGroupProps> = withStyles(() => ({
  grouped: {
    "&:not(:first-child)": {
      borderRadius: "2px",
      marginLeft: "0px",
      border: "none",
    },
    "&:first-child": {
      borderRadius: "2px",
    },
  },
}))(ToggleButtonGroup);

export default IconToggleGroup;
